"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function buildCommunityContentId(type, relatedId, secondaryRelatedId) {
  var contentId = type + "-" + relatedId;
  if (secondaryRelatedId) {
    contentId = contentId + "-" + secondaryRelatedId;
  }

  return contentId;
}

function buildCommunityContentIdFromObject(_ref) {
  var type = _ref.type,
      relatedId = _ref.relatedId,
      secondaryRelatedId = _ref.secondaryRelatedId;

  return buildCommunityContentId(type, relatedId, secondaryRelatedId);
}

exports.default = {
  buildCommunityContentId: buildCommunityContentId,
  buildCommunityContentIdFromObject: buildCommunityContentIdFromObject
};